import {
  FACETS_ACTIVITIES_NAME,
  QUERY_PARAM_PREV_LOCATION,
  QUERY_PARAM_ANY_LOCATION,
} from '../constants';
import { SETUP_INIT_DATA, FETCH_DATA, VIEW, SET_LOADING } from './_types';
import { SET_COLLAPSABLE_EXPANDED_ITEMS, SET_LOCATION_PARAMS } from '../mutations/_types';
import view from './view';
import searchAPI from './searchAPI';

export default {
  [SETUP_INIT_DATA]: ({ state, commit }, { locationCoordinates, queryString: locQueryString }) => {
    // Update location params needed to keep location in search results
    const locationQuery = new URLSearchParams(locQueryString);
    Array.from(locationQuery.keys()).forEach((key) => {
      // Delete all params not related with location
      if (key !== QUERY_PARAM_PREV_LOCATION && key !== QUERY_PARAM_ANY_LOCATION) {
        locationQuery.delete(key);
      }
    });
    if (!locationQuery.has(QUERY_PARAM_ANY_LOCATION) && locationCoordinates) {
      const rawValue = locationCoordinates.replace(`${QUERY_PARAM_ANY_LOCATION}=`, '');
      locationQuery.append(QUERY_PARAM_ANY_LOCATION, rawValue);
    }
    commit(SET_LOCATION_PARAMS, locationQuery.toString());

    // Check if collapsable link list should be expanded on load
    const {
      search: { facets },
    } = state;
    const items = facets
      .filter((f) => f.name === FACETS_ACTIVITIES_NAME)
      .reduce((acc, cur) => {
        const expandedCategories = cur.items.reduce((categories, facet) => {
          const expanded =
            facet.selected || (facet.children && facet.children.some(({ selected }) => selected));
          return { [facet.name]: expanded, ...categories };
        }, {});

        acc[cur.name] = expandedCategories;
        return acc;
      }, {});

    commit(SET_COLLAPSABLE_EXPANDED_ITEMS, items);
  },
  [FETCH_DATA]: searchAPI,
  [VIEW]: (props) => {
    setTimeout(() => {
      view(props);
    }, 250);
  },
  [SET_LOADING]: (context, value) => {
    context.commit(SET_LOADING, value);
  },
};
